// Mirrors backend App\Enums\Auth\UserStatus (string-backed). The cabinet
// reads `auth.user.status` (from GET /auth/me) and the auth guard routes the
// account-lifecycle statuses to a single status screen.
export enum UserStatusEnum {
	pendingEmailVerification = "pending_email_verification",
	pendingDocuments         = "pending_documents",
	pendingModeration        = "pending_moderation",
	active                   = "active",
	suspended                = "suspended",
	rejected                 = "rejected",
	deleted                  = "deleted",
	documentsExpired         = "documents_expired",
}
